// A whole number of 0 or more with an exact JavaScript number, as the bridge's cache versions and times are.
export const isWholeNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isSafeInteger(value) && value >= 0;
